export interface AntumoEventDetail {
  [key: string]: unknown;
}

export function triggerEvent(
  element: Element,
  eventName: string,
  detail: AntumoEventDetail = {},
  cancelable = true
): CustomEvent<AntumoEventDetail> {
  const event = new CustomEvent<AntumoEventDetail>(eventName, {
    bubbles: true,
    cancelable,
    detail,
  });

  element.dispatchEvent(event);
  return event;
}
